"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
class Subscription {
    constructor(props) {
        this.active = props?.active || false;
        this.currency = props?.currency || "";
        this.disabledSpecialties = props?.disabledSpecialties;
        this.disclaimer = props?.disclaimer || "";
        this.discounts = {
            antigenos: props?.discounts?.antigenos || 0,
            especialista: props?.discounts?.especialista || 0,
            guardia: props?.discounts?.guardia || 0,
            hisopados_antigeno: props?.discounts?.hisopados_antigeno || 0,
            pcr: props?.discounts?.pcr || 0,
            pcr_express: props?.discounts?.pcr_express || 0,
            pcr_laboratorio: props?.discounts?.pcr_laboratorio || 0,
            vacuna_antigripal: props?.discounts?.vacuna_antigripal
        };
        this.displayName = props?.displayName || "";
        this.docId = props?.docId || "";
        this.freeMonth = props?.freeMonth || false;
        this.fullPrice = props?.fullPrice || 0;
        this.limitedServices = props?.limitedServices;
        this.mpPlanId = props?.mpPlanId || "";
        this.name = props?.name || "";
        this.paymentData = {
            monthlyPaymentId: props?.paymentData.monthlyPaymentId || "",
            orderId: props?.paymentData.orderId || "",
            paymentMethod: props?.paymentData.paymentMethod || "",
            status: props?.paymentData.status || "pending",
            statusDetail: props?.paymentData.statusDetail || "",
            subscriptionApprovalId: props?.paymentData.subscriptionApprovalId || ""
        };
        this.period = {
            days: props?.period.days || 0,
            finish: props?.period.finish,
            start: props?.period.start
        };
        this.price = props.price || 0;
        this.services = {
            antigenos: props?.services.antigenos || 0,
            especialista: props?.services.especialista || 0,
            especialidades: props?.services.especialidades || {},
            guardia: props?.services.guardia || 0,
            guardiaVip: props?.services.guardiaVip || false,
            hisopado_antigeno: props?.services.hisopado_antigeno || 0,
            pcr: props?.services.pcr || 0,
            pcr_express: props?.services.pcr_express || 0,
            pcr_laboratorio: props?.services.pcr_laboratorio || 0,
            vacuna_antigripal: props?.services.vacuna_antigripal || 0,
            hipertension: props?.services.hipertension || false,
            aptofisico_certificate: props?.services.aptofisico_certificate || 0,
            aptofisico_orders: props?.services.aptofisico_orders || 0,
            aptofisico_orders_certificate: props?.services.aptofisico_orders_certificate || 0,
        };
        this.subtitle = props?.subtitle;
        this.terms = props?.terms;
        this.timestamps = props?.timestamps || {};
        this.uid = props?.uid || "";
        this.bgColor = props?.bgColor || "";
        this.header = props?.header || "";
        this.image = props?.image || "";
        this.title = props?.title || "";
        this.benefits = props?.benefits || [];
        this.options = props?.options || [];
        this.order = props?.order || 0;
    }
}
exports.Subscription = Subscription;
